module.exports = __webpack_public_path__ + "static/img/29.1659f59b.gif";